import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.apps_filter',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change('installed')
  }
}
